import { createUseStyles } from 'react-jss'
import { sizes } from '../../variables.style'

export const style = {
  textarea: {
    padding: sizes.formElementPadding,
    resize: 'none'
  },
  textareaMedium: {
    padding: sizes.formElementMediumPadding,
    resize: 'none'
  }
}

export const useStyles = createUseStyles(style)
